import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import Moment from "react-moment";

const SCRSummaryReportPrint = ({ dataModel, innerRef }) => {
  const hrStyle = {
    marginTop: -5,
    border: "none",
    height: "1px",
  };

  const textOverflow = {
    overflow: "hidden",
    display: "inline-block",
  };

  const [totalVizLinkCollectionSum, setTotalVizLinkCollectionSum] = useState(0);
  const [totalOutSideCollectionSum, setTotalOutSideCollectionSum] = useState(0);
  const [totalBankCollection, setTotalBankCollection] = useState(0);

  const [currentEntity, setCurrentEntity] = useState({
    totalVizLinkCollection: [],
    totalOutSideCollection: [],
    totalBankCollection: [],
  });

  const arraySum = (array) => {
    if (!array || array.length === 0) return 0;
    return array.reduce((sum, item) => sum + (item.amount || 0), 0);
  };

  useEffect(() => {
    if (!dataModel) return;

    const viz = dataModel.totalVizLinkCollection
      ? JSON.parse(JSON.stringify(dataModel.totalVizLinkCollection))
      : [];

    const outside = dataModel.totalOutSideCollection
      ? JSON.parse(JSON.stringify(dataModel.totalOutSideCollection))
      : [];

    const bank = dataModel.totalBankCollection
      ? JSON.parse(JSON.stringify(dataModel.totalBankCollection))
      : [];

    setCurrentEntity({
      totalVizLinkCollection: viz,
      totalOutSideCollection: outside,
      totalBankCollection: bank,
    });

    setTotalVizLinkCollectionSum(arraySum(viz));
    setTotalOutSideCollectionSum(arraySum(outside));
    setTotalBankCollection(arraySum(bank));
  }, [dataModel]);

  const renderTransactionRow = (data) => {
    if (!data) return null;

    return (
      <Row style={{ marginTop: -10 }}>
        <Col sm={6} md={6}>
          <label className="col-form-label pl-4">
            Total Collection Via {data.type}
          </label>
        </Col>
        <Col sm={2} md={2} className="text-center">
          {data.editedAmount ?? 0}
        </Col>
        <Col sm={2} md={2} className="text-center">
          {data.amount ?? 0}
        </Col>
      </Row>
    );
  };

  const renderSummaryColumn = (name, value) => {
    return (
      <div className="row align-items-center">
        <Col sm={7} md={7}>
          <label className="col-form-label">{name}:</label>
        </Col>
        <Col sm={5} md={5}>
          <span style={textOverflow}>{value ?? 0}</span>
        </Col>
      </div>
    );
  };

  const renderCollectionHeading = (name, value) => {
    return (
      <Row>
        <Col sm={10} md={10}>
          <label className="col-form-label">
            <b>{name}</b>
          </label>
        </Col>
        <Col sm={2} md={2} className="text-center">
          <b>{value ?? 0}</b>
        </Col>
      </Row>
    );
  };

  const renderSingleColumn = (name, editedValue, value) => {
    return (
      <>
        <hr style={hrStyle} />
        <Row style={{ marginTop: -10 }}>
          <Col sm={6} md={6}>
            <label className="col-form-label">
              <b>{name}</b>
            </label>
          </Col>
          <Col sm={2} md={2} className="text-center">
            {editedValue ?? 0}
          </Col>
          <Col sm={2} md={2} className="text-center">
            {value ?? 0}
          </Col>
          <Col sm={2} md={2} className="text-center">
            <b>{value ?? 0}</b>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <div className="card mt-3" ref={innerRef}>
      <div className="card-body">
        {!dataModel ? null : (
          <>
            {/* ============ || Main Summary || ============*/}
            <section>
              <Row>
                <Col>
                  {renderSummaryColumn("Distributor", dataModel.distributor)}
                </Col>
                <Col>
                  {renderSummaryColumn("Distribution Center", dataModel.distCenter)}
                </Col>
                <Col>
                  {renderSummaryColumn(
                    "Date",
                    <Moment format="DD/MM/YYYY">
                      {dataModel.date ? dataModel.date : new Date()}
                    </Moment>
                  )}
                </Col>
              </Row>

              <Row style={{ marginTop: -15 }}>
                <Col>
                  {renderSummaryColumn("DLM User ID", dataModel.dlmUserName)}
                </Col>
                <Col>
                  {renderSummaryColumn("DLM Name", dataModel.dlmName)}
                </Col>
                <Col>
                  {renderSummaryColumn("DLM Till ID", dataModel.dlmUserQRCode)}
                </Col>
              </Row>

              <Row style={{ marginTop: -15 }}>
                <Col>
                  {renderSummaryColumn("Invoices in Vizlink", dataModel.totalVizInvoices)}
                </Col>
                 <Col>
                  {renderSummaryColumn("Credit Disbursed", dataModel.totalCreditsIssued)}
                </Col>
                <Col>
                  {renderSummaryColumn("Total Collected", dataModel.totalCollectedAmount)}
                </Col>
              </Row>

              <Row style={{ marginTop: -15 }}>
                <Col>
                  {renderSummaryColumn("Invoices Amount", dataModel.totalInvoicesAmount)}
                </Col>
                <Col>
                  {renderSummaryColumn("Credit Collection", dataModel.totalCreditCollectedAmount)}
                </Col>
                  <Col>
                  {renderSummaryColumn("Collection for pending Invoices", dataModel.totalPendingCollectedAmount)}
                </Col>
              </Row>

              <Row style={{ marginTop: -15 }}>
              
                <Col>
                  {renderSummaryColumn("Updated Invoices Amount", dataModel.totalUpdatedInvoicesAmount)}
                </Col>
                <Col>
                  {renderSummaryColumn("Collection for Re-Open Invoices", dataModel.totalReopenCollectedAmount)}
                </Col>
                 <Col></Col>
              </Row>

              <Row>
                <div className="bg-gray" style={{ width: "100%" }}>
                  <Row>
                    <Col sm={6} md={6}>
                      <label className="col-form-label">Description</label>
                    </Col>
                    <Col sm={2} md={2} className="text-center">
                      <label className="col-form-label">Mode wise Breakup</label>
                    </Col>
                    <Col sm={2} md={2} className="text-center">
                      <label className="col-form-label">Mode wise Breakup</label>
                    </Col>
                    <Col sm={2} md={2} className="text-center">
                      <label className="col-form-label">Amount</label>
                    </Col>
                  </Row>
                </div>
              </Row>
            </section>

            {/* ============ || Form Data || ============*/}
            <section>
              <Row className="mt-2">

                {renderCollectionHeading("Total Collection in Vizlink (M2D)", totalVizLinkCollectionSum)}
                {currentEntity.totalVizLinkCollection.map((data, index) => (
                  <div key={index}>{renderTransactionRow(data)}</div>
                ))}

                <hr style={hrStyle} />
                {renderCollectionHeading("Total Outside Vizlink", totalOutSideCollectionSum)}
                {currentEntity.totalOutSideCollection.map((data, index) => (
                  <div key={index}>{renderTransactionRow(data)}</div>
                ))}

                <hr style={hrStyle} />
                {renderCollectionHeading("Total Collection in Bank", totalBankCollection)}
                {currentEntity.totalBankCollection.map((data, index) => (
                  <div key={index}>{renderTransactionRow(data)}</div>
                ))}

                {renderSingleColumn("Total Cash Collected", dataModel.totalCashCollected_Edited, dataModel.totalCashCollected)}
                {renderSingleColumn("Total Credit Disbursed", dataModel.totalCreditDisbursed_Edited, dataModel.totalCreditDisbursed)}
                {renderSingleColumn("Total RTG", dataModel.totalRTG_Edited, dataModel.totalRTG)}
                {renderSingleColumn("Total Market Return", dataModel.totalMarketReturn_Edited, dataModel.totalMarketReturn)}
                {renderSingleColumn("Total With Holding Tax", null, dataModel.totalWithHoldingTax)}
                {renderSingleColumn("Total Additional Sale", dataModel.totalAdditionalSale_Edited, dataModel.totalAdditionalSale)}

                <hr style={hrStyle} />
                <Row style={{ marginTop: -10 }}>
                  <Col sm={10} md={10}>
                    <label className="col-form-label">
                      <b>Outstanding Amount</b>
                    </label>
                  </Col>
                  <Col sm={2} md={2} className="text-center">
                    <b>{dataModel.outstandingAmount ?? 0}</b>
                  </Col>
                </Row>

                <hr style={hrStyle} />
                <Row style={{ marginTop: -10 }}>
                  <Col sm={10} md={10}>
                    <label className="col-form-label">
                      <b>Total Cash Deposit in Bank</b>
                    </label>
                  </Col>
                  <Col sm={2} md={2} className="text-center">
                    <b>{dataModel.totalCashInBankDeposit ?? 0}</b>
                  </Col>
                </Row>

                <Row style={{ marginTop: -10 }}>
                  <Col sm={10} md={10}>
                    <label className="col-form-label">
                      <b>Total Cash in Hand</b>
                    </label>
                  </Col>
                  <Col sm={2} md={2} className="text-center">
                    <b>{dataModel.totalCashInHand ?? 0}</b>
                  </Col>
                </Row>

              </Row>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default SCRSummaryReportPrint;